import { useEffect, useRef } from "react";
import { useProjectContext } from "@contexts/projects";
import { buildProjectionRequestKey } from "@contexts/projects/projectionScope";
import LoaderItem from "./accordion/LoaderItem";

const FALLBACK_MESSAGE = "Não foi possível carregar esta parte da projeção.";
const VISUALLY_HIDDEN = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
};

const LEVEL_LABELS = {
  units: "unidades",
  cells: "células",
  steps: "etapas",
  substeps: "subetapas",
  services: "serviços",
};

const ProjectionLoadState = ({
  level,
  parent,
  parentLabel,
  isMissing,
  onRetry,
  focusTargetId,
  showErrorCode = false,
}) => {
  const { projectionLoads = {} } = useProjectContext();
  const load = projectionLoads[buildProjectionRequestKey(level, parent)];
  const retryPending = useRef(false);

  useEffect(() => {
    if (!retryPending.current || load?.status !== "success" || isMissing) return;
    retryPending.current = false;
    document.getElementById(focusTargetId)?.focus({ preventScroll: true });
  }, [focusTargetId, isMissing, load?.status]);

  const retry = () => {
    retryPending.current = true;
    onRetry();
  };

  if (load?.status === "error") {
    return (
      <div className="alert alert-error margin-bottom-8" role="alert">
        <p>
          {showErrorCode && <><strong>projection_load_failed</strong>: </>}
          {load.error?.message || FALLBACK_MESSAGE}
        </p>
        <button type="button" className="button button-secondary small" onClick={retry}>
          Tentar novamente
        </button>
      </div>
    );
  }

  if (load?.status === "loading" || isMissing) {
    const subject = parentLabel || parent;
    const levelLabel = LEVEL_LABELS[level] || "dados";
    const loadingDescription = subject
      ? `Carregando ${levelLabel} de ${subject}`
      : `Carregando ${levelLabel}`;
    return (
      <div className="value-hierarchy-load" role="status" aria-live="polite">
        <span style={VISUALLY_HIDDEN}>{loadingDescription}</span>
        <LoaderItem />
      </div>
    );
  }
  return null;
};

export default ProjectionLoadState;
